import { useEffect, useState } from "react";
import { Providers, ProviderState } from "@microsoft/mgt-element";

const useGetCurrentUser = () => {
  const [currentUser, setCurrentUser] = useState(null);

  useEffect(() => {
    const updateState = () => {
      setCurrentUser(Providers.globalProvider.getAllAccounts()[0]);
    };

    Providers.globalProvider.onActiveAccountChanged(updateState);
    updateState();

    return () => {
      Providers.removeProviderUpdatedListener(updateState);
    };
  }, []);

  return currentUser;
};

export default useGetCurrentUser;
